import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginPage } from './pages/login/login.component';
import { InputComponent } from './components/input/input.component';
import { ButtonComponent } from './components/button/button.component';
import { DashboardPage } from './pages/dashboard/dashboard.component';
import { HeaderTitleComponent } from './components/header-title/header-title.component';
import { HeaderComponent } from './components/header/header.component';
import { AddSlokaTypePage } from './pages/add-sloka-type/add-sloka-type.component';
import { AddSlokaPage } from './pages/add-sloka/add-sloka.component';
import { SlokasListPage } from './pages/slokas-list/slokas-list.component';
import { SlokaTypesListPage } from './pages/sloka-types-list/sloka-types-list.component';
import { TableComponent } from './components/table/table.component';
import { HttpClientModule } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { UsersPage } from './pages/users/users.component';
import { PopupComponent } from './components/popup/popup.component';
import { AddOfferPage } from './pages/add-offer/add-offer.component';
import { ProfilePage } from './pages/profile/profile.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from '../environments/environment';
import { AddBookComponent } from './pages/add-book/add-book.component';
import { BooksListComponent } from './pages/books-list/books-list.component';
import { BooksTableComponent } from './components/books-table/books-table.component';
import { EventTableComponent } from './components/event-table/event-table.component';
import { EventListComponent } from './pages/event-list/event-list.component';
import { AddEventComponent } from './pages/add-event/add-event.component';
import { AddBlogPostComponent } from './pages/add-blog-post/add-blog-post.component';
import { BlogPostListComponent } from './pages/blog-post-list/blog-post-list.component';
import { BlogPostsTableComponent } from './components/blog-posts-table/blog-posts-table.component'

@NgModule({
  declarations: [
    AppComponent,
    LoginPage,
    InputComponent,
    ButtonComponent,
    DashboardPage,
    HeaderTitleComponent,
    HeaderComponent,
    AddSlokaTypePage,
    AddSlokaPage,
    SlokasListPage,
    SlokaTypesListPage,
    TableComponent,
    UsersPage,
    PopupComponent,
    AddOfferPage,
    ProfilePage,
    AddBookComponent,
    BooksListComponent,
    BooksTableComponent,
    EventTableComponent,
    EventListComponent,
    AddEventComponent,
    AddBlogPostComponent,
    BlogPostListComponent,
    BlogPostsTableComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
